var _path, _path2, _g, _rect, _path3, _circle, _circle2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoPpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 93,
    viewBox: "0 0 78 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_459_282",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 0,
    width: 72,
    height: 93
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5C6 2.23858 8.23858 0 11 0H42.931H48.1285C49.4691 0 50.7535 0.538347 51.6935 1.4942L64.0345 14.0436L76.5256 26.4651C77.4694 27.4035 78 28.6795 78 30.0105V55.8624V88C78 90.7614 75.7614 93 73 93H11C8.23857 93 6 90.7614 6 88V5Z",
    fill: "#EDEDED"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_459_282)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: -29,
    width: 56,
    height: 56,
    fill: "#D9D9D9"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 67,
    width: 48,
    height: 20,
    rx: 3,
    fill: "#FF973C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7706 82.5V72.3182H14.9766C15.7389 72.3182 16.3968 72.4673 16.9503 72.7656C17.5071 73.0606 17.9363 73.4732 18.2379 74.0036C18.5395 74.5305 18.6903 75.1437 18.6903 75.843C18.6903 76.5457 18.5362 77.1605 18.228 77.6875C17.9231 78.2112 17.4872 78.6172 16.9205 78.9055C16.3537 79.1939 15.6809 79.3381 14.902 79.3381H12.3068V77.3991H14.4446C14.8158 77.3991 15.1257 77.3345 15.3743 77.2053C15.6262 77.076 15.8168 76.8954 15.946 76.6634C16.0753 76.428 16.1399 76.1546 16.1399 75.843C16.1399 75.5282 16.0753 75.2564 15.946 75.0277C15.8168 74.7957 15.6262 74.6167 15.3743 74.4908C15.1224 74.3648 14.8125 74.3018 14.4446 74.3018H13.2315V82.5H10.7706ZM19.9034 82.5V72.3182H24.1094C24.8717 72.3182 25.5296 72.4673 26.0831 72.7656C26.6399 73.0606 27.0691 73.4732 27.3707 74.0036C27.6723 74.5305 27.8232 75.1437 27.8232 75.843C27.8232 76.5457 27.669 77.1605 27.3608 77.6875C27.0559 78.2112 26.62 78.6172 26.0533 78.9055C25.4865 79.1939 24.8137 79.3381 24.0348 79.3381H21.4396V77.3991H23.5774C23.9486 77.3991 24.2585 77.3345 24.5071 77.2053C24.759 77.076 24.9496 76.8954 25.0788 76.6634C25.2081 76.428 25.2727 76.1546 25.2727 75.843C25.2727 75.5282 25.2081 75.2564 25.0788 75.0277C24.9496 74.7957 24.759 74.6167 24.5071 74.4908C24.2552 74.3648 23.9453 74.3018 23.5774 74.3018H22.3643V82.5H19.9034ZM28.7031 74.3168V72.3182H37.3089V74.3168H34.2216V82.5H31.7955V74.3168H28.7031Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 47,
    r: 16,
    fill: "#FFCFA4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_459_282",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 26,
    y: 31,
    width: 32,
    height: 32
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 47,
    r: 16,
    fill: "#FFDAB9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_459_282)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 18.6364,
    width: 28.3636,
    height: 28.3636,
    fill: "#FF973B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPpt);
export default __webpack_public_path__ + "static/media/ico_ppt.3997d0e76bec594e90a7879af469c55c.svg";
export { ForwardRef as ReactComponent };